// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
 
// const Carousel = () => {
//   // Define the images
//   const images = [
//     "images/caroselimg.png",
//     "images/caroselimg6.jpg",
//     "images/carosel8.jpg"
//   ];
 
//   const [currentIndex, setCurrentIndex] = useState(0);
 
//   // Auto-slide every 3 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       goToNext();
//     }, 3000);
//     return () => clearInterval(interval);
//   }, [currentIndex]);
 
//   const goToPrevious = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? images.length - 1 : prevIndex - 1
//     );
//   };
 
//   const goToNext = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === images.length - 1 ? 0 : prevIndex + 1
//     );
//   };
 
//   return (
//     <div className="relative w-full overflow-hidden ">
//       {/* Image Slider */}
//       <div className=" h-screen">
//         <img
//           src={images[currentIndex]}
//           alt={`slide-${currentIndex}`}
//           className="w-full absolute object-cover left-0 right-0 h-screen sm:h-[600px] md:h-[700px] lg:h-screen   "
//         />

        
//       </div>
//    {/* Social Links */}
//    <div className=" hidden md:block absolute top-20  md:top-32  right-5 md:right-3 bg-transparent opacity-80">
//         <ul className="flex flex-col gap-6 items-center sm:items-start">
//           {["fb", "insta", "linkedin", "x", "mail"].map((icon, idx) => (
//             <li key={idx}>
//               <a href="#" className="hover:underline">
//                 <img src={`images/${icon}.png`} alt={icon} className="w-8 h-8 text-white" />
//               </a>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Text Overlay */}
//       <div className="absolute left-8 top-[20%] md:top-[15%] md:left-10 xl:left-40 flex flex-col text-center items-center md:items-start text-4xl xl:text-4xl font-bold tracking-widest z-20 px-2">
//         {["ELEVATE", "YOUR", "SPACE"].map((word, idx) => (
//           <h2 key={idx} className="text-[#4f4741] font-Montserrat font-semibold text-5xl md:text-8xl lg:text-7xl xl:text-[100px] 2xl:text-[150px] leading-[60px] md:leading-0">
//             {word}
//           </h2>
//         ))}
//       </div>

//  <div className="flex flex-col sm:flex-row absolute top-[45%] md:top-1/2 xl:top-1/2 xl:pt-12 2xl:top-[60%] left-1/2 md:left-56 lg:left-1/4 xl:left-[400px] transform -translate-x-1/2 gap-6 md:gap-3 xl:gap-6 sm:gap-10 z-20">
//       <Link to="/zebreblinds">
//         <button className="text-sm md:text-md xl:text-xl border-2 bg-white border-[#b4b0b0] px-6 py-2 xl:py-2 md:px-8 w-40 md:w-40 xl:w-52 text-black">
//           BLINDS
//         </button>
//       </Link>
//       <Link to="/aurashades">
//         <button className="text-sm md:text-md xl:text-xl border-2 bg-white border-[#b4b0b0] px-6 py-2 xl:py-2 md:px-8 w-40 md:w-40 xl:w-52 text-black">
//           SHADES
//         </button>
//       </Link>
//     </div>
//       {/* Dots Indicator */}
//       <div className="absolute bottom-32 left-0 right-0 flex justify-center space-x-2">
//         {images.map((_, index) => (
//           <span
//             key={index}
//             className={`w-3 h-3 rounded-full ${
//               index === currentIndex ? 'bg-white' : 'bg-gray-400'
//             }`}
//             onClick={() => setCurrentIndex(index)}
//           ></span>
//         ))}
//       </div>
//     </div>
//   );
// };
 
// export default Carousel;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const Carousel = () => {
//   const images = [
//     "images/caroselimg.png",
//     "images/caroselimg6.jpg",
//     "images/carosel8.jpg",
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       goToNext();
//     }, 3000);
//     return () => clearInterval(interval);
//   }, [currentIndex]);

//   const goToPrevious = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? images.length - 1 : prevIndex - 1
//     );
//   };

//   const goToNext = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === images.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   return (
//     <div className="relative w-full overflow-hidden">
//       {/* Image Slider */}
//       <div className="h-screen">
//         <img
//           src={images[currentIndex]}
//           alt={`slide-${currentIndex}`}
//           className="w-full absolute object-cover left-0 right-0 h-screen sm:h-[600px] md:h-[700px] lg:h-screen"
//         />
//       </div>

//       {/* Social Links */}
//       <div className="hidden md:block absolute top-20 md:top-32 right-5 md:right-3 bg-transparent opacity-80">
//         <ul className="flex flex-col gap-6 items-center sm:items-start">
//           {["fb", "insta", "linkedin", "x", "mail"].map((icon, idx) => (
//             <li key={idx}>
//               <a href="#" className="hover:underline">
//                 <img
//                   src={`images/${icon}.png`}
//                   alt={icon}
//                   className="w-8 h-8 text-white"
//                 />
//               </a>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Text Overlay */}
//       <div className=" text-4xl xl:text-9xl font-bold">
//         <p>ELEVATE</p>
//         <p>YOUR</p>
//         <p>SPACE</p>
//       </div>

//    {/* Buttons Section */}
//    <div className=" ">
//         <Link to="/zebreblinds">
//           <button className="text-sm md:text-md xl:text-xl border-2 bg-white border-[#b4b0b0] px-6 py-2 xl:py-2 md:px-8 w-40 md:w-40 xl:w-52 text-black">
//             BLINDS
//           </button>
//         </Link>
//         <Link to="/aurashades">
//           <button className="text-sm md:text-md xl:text-xl border-2 bg-white border-[#b4b0b0] px-6 py-2 xl:py-2 md:px-8 w-40 md:w-40 xl:w-52 text-black">
//             SHADES
//           </button>
//         </Link>
//       </div>

// {/* Dots Indicator */}
// <div className="absolute bottom-32 left-0 right-0 flex justify-center space-x-2">
//         {images.map((_, index) => (
//           <span
//             key={index}
//             className={`w-3 h-3 rounded-full ${
//               index === currentIndex ? "bg-white" : "bg-gray-400"
//             }`}
//             onClick={() => setCurrentIndex(index)}
//           ></span>
//         ))}
//       </div>
//     </div>
//   );
// };
// export default Carousel;

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Carousel = () => {
  const images = [
    "images/landingcarosel2.jpg",
    "images/landingcarosel3.jpg",
    "images/landingcarosel5.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);


  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="relative w-full overflow-hidden">
      {/* Image Slider */}
      <div className="h-[550px] sm:h-[600px] md:h-[700px] lg:h-[800px] xl:h-[850px] relative">
        <img
          src={images[currentIndex]}
          alt={`slide-${currentIndex}`}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      {/* Social Links */}
      <div className="hidden md:block absolute top-20 md:top-28 right-5 bg-transparent opacity-80">
        <ul className="flex flex-col gap-4">
          {["fb", "insta", "linkedin", "x", "mail"].map((icon, idx) => (
            <li key={idx}>
              <a href="#" className="hover:opacity-80">
                <img
                  src={`images/${icon}.png`}
                  alt={icon}
                  className="w-6 md:w-8"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Text Overlay */}
      <div className="absolute bg-white max-w-3xl bg-opacity-60 p-6 sm:p-8 md:p-12 rounded-2xl text-[#314c61] left-4 sm:left-10 md:left-20 lg:left-24 top-1/4 md:top-32 w-11/12 sm:w-4/5 md:w-3/5 lg:w-1/2 xl:w-2/5 text-center">

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif">ELEVATE</h1>
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif">YOUR</h1>
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-cookie font-bold">SPACE</h1>

        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
          <Link to="/zebreblinds">
            <button className="text-sm sm:text-base lg:text-lg font-semibold border-2 bg-white border-[#0e1f32] hover:bg-[#426ea1] hover:text-white px-5 py-2 sm:px-6 sm:py-2 lg:px-8 w-32 sm:w-36 lg:w-40 text-black">
              BLINDS
            </button>
          </Link>
          <Link to="/aurashades">
            <button className="text-sm sm:text-base lg:text-lg font-semibold border-2 bg-white border-[#0e1f32] hover:bg-[#426ea1] hover:text-white px-5 py-2 sm:px-6 sm:py-2 lg:px-8 w-32 sm:w-36 lg:w-40 text-black">
              SHADES
            </button>
          </Link>
        </div>
      </div>

      {/* Dots Indicator */}
      <div className="absolute bottom-8 sm:bottom-12 left-0 right-0 flex justify-center space-x-2">
        {images.map((_, index) => (
          <span
            key={index}
            className={`w-3 h-3 rounded-full cursor-pointer ${
              index === currentIndex ? "bg-white" : "bg-gray-400"
            }`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Carousel;



     